import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, CardBody, Col, Table, UncontrolledTooltip, Badge,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import CalendarIcon from 'mdi-react/CalendarIcon';
import MinusIcon from 'mdi-react/MinusIcon';
import Moment from 'moment';
import parse from 'html-react-parser';
import swal from 'sweetalert';

import TransactionDelete from './TransactionDelete';
import TransactionModal from './TransactionModal';
import ProductListsModal from './ProductListsModal';
import CommonService from '../../../services/CommonService';
import global from '../../../global';

class TransactionLists extends Component {
  static propTypes = {
    pageTitle: PropTypes.string,
    pagetype: PropTypes.string,
  };

  static defaultProps = {
    pageTitle: 'Transactions',
    pagetype: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      list: [],
      modal: false,
      errorMsg: '',
      formdata: {},
      salesid: '',
      title: '',
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.transactionToggle = this.transactionToggle.bind(this);
    this.searchTransaction = this.searchTransaction.bind(this);
    this.isLoading = false;
    this.userdata = JSON.parse(localStorage.getItem('userData'));
  }

  componentDidMount() {
    this.isLoading = true;
    this.onLoadSales();
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  onLoadSales = async (fromDate = '', toDate = '') => {
    this.isLoading = true;
    try {
      const { pagetype } = this.props;
      const dateFrom = fromDate !== '' ? fromDate : Moment(new Date()).format('YYYY-MM-DD');
      const dateTo = toDate !== '' ? toDate : Moment(new Date()).format('YYYY-MM-DD');
      let locationwhere = '';
      let pagewhere = '';
      if (this.userdata.type !== '1' && this.userdata.type !== '5') {
        locationwhere = `/locationid/${this.userdata.location_id}`;
      }

      if (pagetype !== '') {
        pagewhere = `/pagetype/${pagetype}`;
      }
      const response = await CommonService.getRows(`sales/fromdate/${dateFrom}/to/${dateTo}${locationwhere}${pagewhere}`);
      if (this.isLoading && (response !== false || response !== '')) {
        this.setState({ list: response });
      }
      this.isLoading = false;
    } catch (err) {
      console.log('Error: ', err.message);
      this.isLoading = false;
    }
  }

  handleChange = (e, fieldName) => {
    if (fieldName === 'fromDate') {
      const date = new Date(e);
      this.setState(prevState => ({
        formdata: {
          ...prevState.formdata,
          fromDate: date,
        },
      }));
    } else if (fieldName === 'toDate') {
      const date = new Date(e);
      this.setState(prevState => ({
        formdata: {
          ...prevState.formdata,
          toDate: date,
        },
      }));
    } else {
      const { name, value } = e.target;
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, [name]: value },
      }));
    }
  }

  delteTransaction = async (e, salesid) => {
    e.preventDefault();
    const { list } = this.state;
    const form = document.getElementById('delete_transaction_form');
    const formdata = new FormData(form);
    formdata.append('sales_id', salesid);
    formdata.append('user_id', this.userdata.user_id);

    try {
      const result = await CommonService.updateData('deletestoretransction', formdata, false);
      if (result) {
        if (result.result === true) {
          this.setState({ list, errorMsg: '', modal: false });
          this.onLoadSales();
          swal('', 'Successfully update transaction', 'success');
        } else {
          this.setState({ errorMsg: result.msg });
        }
      } else {
        swal('', 'Failed to update transaction', 'error');
      }
    } catch (err) {
      console.log('Error: ', err.message);
    }
  }

  transactionToggle(e, action = 'add', salesid = '') {
    e.preventDefault();
    this.toggleModal();
    this.executeModal = 'transaction';
    this.setState({ action });

    if (action === 'delete') {
      this.executeModal = 'transactionremove';
      this.setState({ salesid });
      this.setState({ title: 'Delete Transaction' });
      this.handleSubmit = (ev) => { this.delteTransaction(ev, salesid); };
    } else {
      this.setState({ title: 'Add Transaction' });
      this.handleSubmit = (ev) => { this.addTransaction(ev); };
    }
  }

  async addTransaction(e) {
    e.preventDefault();
    const { list } = this.state;
    const form = document.getElementById('store_transaction_form');
    const formdata = new FormData(form);
    formdata.append('location_id', this.userdata.location_id);
    formdata.append('user_id', this.userdata.user_id);

    try {
      const result = await CommonService.insertData('addstoretransaction', formdata, false);
      if (result) {
        if (result.msg === true) {
          // update list
          this.onLoadSales();
          this.setState({ list, errorMsg: '', modal: false });

          swal({
            title: 'Successfully added transaction!',
            text: 'Add new transaction?',
            icon: 'warning',
            closeOnClickOutside: false,
            buttons: {
              yes: 'ADD NEW',
              no: 'NOPE',
            },
          }).then((name) => {
            name = name.toLowerCase();

            if (name === 'yes') {
              this.toggleModal();
              this.executeModal = 'transaction';
              this.setState({ action: 'add' });
            }
          });
        } else {
          this.setState({ errorMsg: result.msg });
        }
      } else {
        swal('', 'Failed to add inventory', 'warning');
      }
    } catch (err) {
      console.log('Error: ', err.message);
    }
  }

  searchTransaction(e) {
    e.preventDefault();
    const { formdata } = this.state;
    const fromDate = Moment(formdata.fromDate).format('YYYY-MM-DD');
    const toDate = Moment(formdata.toDate).format('YYYY-MM-DD');
    this.onLoadSales(fromDate, toDate);
  }

  viewproducts(e, paramdata) {
    e.preventDefault();
    const {
      salesid, total, amountPaid, balance,
    } = paramdata;
    this.executeModal = 'viewproducts';
    this.toggleModal();
    this.setState({
      salesid, total, amountPaid, balance,
    });
  }

  toggleModal() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  render() {
    const {
      list, modal, errorMsg, formdata, salesid, total, amountPaid, balance, action, title,
    } = this.state;
    const { pageTitle } = this.props;

    // from date
    let fromDate = new Date();
    if (formdata.fromDate) {
      fromDate = new Date(formdata.fromDate);
    }
    // to date
    let toDate = new Date();
    if (formdata.toDate) {
      toDate = new Date(formdata.toDate);
    }

    return (
      <Col md={12}>
        {
          this.executeModal === 'transaction' ? (
            <TransactionModal
              title={title}
              modal={modal}
              toggle={this.toggleModal}
              handleSubmit={this.handleSubmit}
              errorMsg={errorMsg}
              salesid={salesid}
              action={action}
            />
          ) : this.executeModal === 'transactionremove' ? (
            <TransactionDelete
              modal={modal}
              toggle={this.toggleModal}
              handleSubmit={this.handleSubmit}
              errorMsg={errorMsg}
              salesid={salesid}
            />
          ) : this.executeModal === 'viewproducts' ? (
            <ProductListsModal
              salesId={salesid}
              toggle={this.toggleModal}
              modal={modal}
              total={total}
              amountPaid={amountPaid}
              balance={balance}
            />
          ) : ''
        }
        <Card className="panel panel--primary do_magic" id="users_table">
          <CardBody className="panel__body">
            <div className="panel__title bg_blue">
              <h5 className="bold-text">{pageTitle.toUpperCase()}</h5>
              {
                this.userdata && this.userdata.type === '4' && (
                  <div className="panel__btns">
                    <Button onClick={this.transactionToggle} className="rounded text-white btn-awesome" size="sm" outline>
                      <i className="fa fa-shopping-cart" />
                      <span>Add New Transaction</span>
                    </Button>
                  </div>
                )
              }
            </div>
            <div className="panel__content">
              {/* Search Form */}
              <div className="float-right">
                <form className="form form--horizontal" onSubmit={this.searchTransaction}>
                  <div className="form__form-group">
                    <div className="form__form-group-field rfull-width">
                      <span className="form__form-group-label text-right m-r-10 mw-45 xw-45">Date:</span>
                      <div className="form__form-group-icon">
                        <CalendarIcon />
                      </div>
                      <DatePicker
                        name="fromDate"
                        selected={fromDate}
                        popperPlacement="top"
                        onChange={e => this.handleChange(e, 'fromDate')}
                      />
                      <MinusIcon className="date-picker__svg m-t-5" />
                      <div className="form__form-group-icon">
                        <CalendarIcon />
                      </div>
                      <DatePicker
                        name="toDate"
                        selected={toDate}
                        popperPlacement="top-end"
                        onChange={e => this.handleChange(e, 'toDate')}
                      />
                      <button type="submit" className="form__form-group-button bg-primary"><i className="fa fa-search" /></button>
                    </div>
                  </div>
                </form>
              </div>
              {/* Table */}
              <Table responsive striped className="doResTable">
                <thead>
                  <tr>
                    <th>Customer</th>
                    <th>Reference No.</th>
                    {
                      (this.userdata.type === '1' || this.userdata.type === '5') && (
                        <th>Location</th>
                      )
                    }
                    <th className="text-center">Total</th>
                    <th className="text-center">Amount Paid</th>
                    <th className="text-center">Balance</th>
                    <th className="text-center">Date</th>
                    <th className="text-center">Status</th>
                    <th className="text-center">Reason</th>
                    <th width="10%" className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    list !== false || list.length > 0 ? list.map((item, i) => {
                      const param = {
                        salesid: item.sales_id,
                        total: item.total,
                        amountPaid: item.amount_paid,
                        balance: item.balance,
                      };
                      const currBalance = parseFloat(item.balance);
                      console.log(item);

                      return (
                        <tr key={`customer_row${i + 1}`} className="text-center">
                          <td className="text-left">{item.customer_name}</td>
                          <td className="text-left">{item.dr_number !== '' ? item.dr_number : '- -- -'}</td>
                          {
                            (this.userdata.type === '1' || this.userdata.type === '5') && (
                              <td className="text-left">{item.location_name}</td>
                            )
                          }
                          <td className="text-primary">&#x20B1; {item.total}</td>
                          <td className="text-success">&#x20B1; {item.amount_paid}</td>
                          <td className="text-danger">{currBalance > 0 ? parse(`&#x20B1; ${global.numberFormat(currBalance)}`) : '-'}</td>
                          <td>{item.date_sales}</td>
                          <td>{item.archive === '1' ? <Badge color="danger">Archived</Badge> : '- -- -'}</td>
                          <td>{item.archive === '1' ? item.reason : '- -- -'}</td>
                          <td className="text-center">
                            {/* <Button color="success" className="btn-xs" onClick={e => this.transactionToggle(e, 'edit', item.sales_id)} id={`edittransactionbtn${i + 1}`} outline><span className="lnr lnr-pencil" /></Button>
                            <UncontrolledTooltip target={`edittransactionbtn${i + 1}`}>Edit</UncontrolledTooltip> */}
                            {
                              item.archive === '0' && (
                                <>
                                  <Button color="danger" className="btn-xs" onClick={e => this.transactionToggle(e, 'delete', item.sales_id)} id={`deletetransactionbtn${i + 1}`} outline><span className="fa fa-archive" /></Button>
                                  <UncontrolledTooltip target={`deletetransactionbtn${i + 1}`}>Archive Transaction</UncontrolledTooltip>
                                </>
                              )
                            }
                            <Button color="primary" className="btn-xs" onClick={e => this.viewproducts(e, param)} id={`viewprodbtn${i + 1}`} outline><span className="fa fa-eye" /></Button>
                            <UncontrolledTooltip target={`viewprodbtn${i + 1}`}>View Products</UncontrolledTooltip>
                          </td>
                        </tr>
                      );
                    }) : (
                      <tr className="text-center">
                        <td colSpan="9">No data available..</td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withTranslation('common')(TransactionLists);
